import type MeetingMessage from 'owa-service/lib/contract/MeetingMessage';

export function isMeetingDelegated(message: MeetingMessage): boolean {
    return !!message.IsDelegated && !!message.ReceivedRepresenting;
}
